import type { Middleware, MiddlewareAPI } from '@reduxjs/toolkit';
import type { Socket } from 'socket.io-client';

import { type TranslationDataInEditMode, translationEditorActions } from './pages/Editor/reducers';

const { addTranslationsInEditMode, removeTranslationFromEditMode } = translationEditorActions;

function waitForSocket() {
    function waitForSocketInitialized(resolve: (socket: Socket) => void) {
        if ('globalSocket' in window && window.globalSocket) {
            resolve(window.globalSocket as Socket);
        } else {
            setTimeout(() => waitForSocketInitialized(resolve), 50);
        }
    }

    return new Promise(waitForSocketInitialized);
}

export const projectMiddleware: Middleware = (api: MiddlewareAPI) => (next) => {
    waitForSocket().then((socket) => {
        socket.on('translation edit start', (data: TranslationDataInEditMode) => {
            api.dispatch(addTranslationsInEditMode([{ translationId: data.translationId, userName: data.userName }]));
        });

        socket.on('translation edit end', (data: { translationId: number }) => {
            api.dispatch(removeTranslationFromEditMode({ translationId: data.translationId }));
        });
    });

    return (action) => next(action);
};

export default projectMiddleware;
